import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { ElectronicModel } from '@/types';
import { useDeleteElectronicModelMutation } from '@/services';

export interface DeleteElectronicModelProps extends DialogProps {
  electronicModel: ElectronicModel;
  onClose(): void;
}

const DeleteElectronicModel: React.FC<DeleteElectronicModelProps> = ({ electronicModel, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteElectronicModel, deleteElectronicModelResponse] = useDeleteElectronicModelMutation();

  async function handleDeleteElectronicModel() {
    try {
      await deleteElectronicModel(electronicModel).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{electronicModel?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{electronicModel?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="secondary"
          variant="outlined"
          disabled={deleteElectronicModelResponse.isLoading}
          onClick={onClose}
        >
          Закрыть
        </Button>

        <Button
          variant="contained"
          disabled={deleteElectronicModelResponse.isLoading}
          onClick={handleDeleteElectronicModel}
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteElectronicModel;
